import { Button } from "@datamole/wds-component-button";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Title as RadixTitle, Close as RadixClose } from "@radix-ui/react-dialog";
import clsx from "clsx";
import { forwardRef, type ReactNode, type HTMLAttributes } from "react";

import styles from "./header.module.css";

type Props = HTMLAttributes<HTMLHeadingElement> & {
    closeIcon?: ReactNode;
};

const Header = forwardRef<HTMLHeadingElement, Props>((props, ref) => {
    const { className, children, closeIcon, ...otherProps } = props;

    return (
        <RadixTitle {...otherProps} ref={ref} className={clsx(styles.header, className)}>
            {children}
            <RadixClose asChild>
                <Button variant="text" size="md" className={styles.close_button}>
                    <Button.Icon>{closeIcon ?? <FontAwesomeIcon icon={faXmark} />}</Button.Icon>
                </Button>
            </RadixClose>
        </RadixTitle>
    );
});

Header.displayName = "Dialog.Content.Header";

export { Header as DialogContentHeader };
export type { Props as DialogContentHeaderProps };
